export const deliverySettings = {
	title: "Configurar Delivery e Integraciones",
	description: "Intégrese con un Delivery asociado y centralice su gestión en Zig.",
	integrateButton: "Nueva integración",
	tabs: {
		management: "Gestión de integraciones",
		integrate: "Integrar delivery",
		configuration: "Configuraciones",
	},
	integrate: {
		steps: {
			systemLabel: "Seleccionar sistema de integración",
			authLabel: "Autenticar integración",
			syncMenuLabel: "Sincronizar menú",
			systemAndAuth: {
				titleSystemIntegration: "Sistema de integración",
				titleAuth: "Autenticación en el sistema asociado",
				descriptionIFood: "Pegue aquí su Clave de API proporcionada por IFood.",
				descriptionAuthRappi: "Pegue aquí su Clave de API proporcionada por Rappi.",
				labelSelect: "Seleccione con quién vamos a integrar",
				labelInput: "ID de la tienda",
				labelCNPJ: "RFC de la tienda",
				errorCNPJRequired: "RFC es requerido",
				placeholderInputIFood: "Pegue aquí el código copiado de iFood",
				placeholderInputRappi: "Pegue aquí el código copiado de Rappi",
				placeholderInput: "Pegue aquí el código",
				placeholderCNPJ: "Ingrese el RFC",
				submitButton: "Seguir con integración",
				buttonAddMore: "Agregar una tienda más",
				avisoTitle: "Necesitamos autorización para integrar con Rappi",
				avisoDescription:
					"Envíe una solicitud a nuestra atención y nos pondremos en contacto para seguir con el proceso de integración.",
				iFoodDialog: {
					title: "Necesitamos autorización para integrar",
					description:
						"Para seguir con la integración con iFood, es necesaria su confirmación de solicitud. Para esto, debe acceder al sistema y generar una Clave de API. Cuando copie la Clave de iFood, regrese para seguir con la integración.",
					cancelButton: "Cancelar integración",
					openButton: "Abrir iFood",
				},
			},
			syncMenu: {
				title: "¡Pronto podrá importar su menú!",
				descriptionIFood:
					"En algunas semanas podrá importar su menú de iFood y usarlo también en nuestro sistema.",
				descriptionRappi:
					"En algunas semanas podrá importar su menú de Rappi y usarlo también en nuestro sistema.",
				syncOffMenuButton: "Completar integración sin menú",
				syncPending: {
					title: "Traiga su menú a Zig",
					description:
						"Asocie su menú de {{externalStoreType}} con los productos registrados en Zig y tenga una gestión centralizada.",
					syncMenuButton: "Sincronizar menú de {{externalStoreType}}",
					syncLate: "Sincronizar después",
				},
				importPending: {
					title: "Traiga su menú a Zig",
					description:
						"Puede importar su menú de {{externalStoreType}} y usarlo también en nuestro sistema.",
					syncMenuButton: "Importar menú de {{externalStoreType}}",
					completeWithoutMenu: "Completar integración sin menú",
				},
			},
		},
	},
	management: {
		newMerchantTitle: "Agregar nueva tienda",
		newMerchantButton: "Agregar tienda",
		labelInput: "ID de la tienda",
		integrationDescription: "Integración vía API",
		integrationDescriptionWithDate: "Integración vía API - {{date}}",
		removeIntegration: "Eliminar integración",
		saveChanges: "Guardar cambios",
		backToImport: "Continuar Importación",
		syncMenu: "Continuar Sincronización",
		merchants: "Tiendas",
		active: "Activo",
		activeIntegration: "Activar integración",
		disableIntegration: "Desactivar integración",
		integrationSuccess: "Integración actualizada con éxito",
		integrationError:
			"Error al actualizar la integración. Por favor, inténtelo de nuevo.",
		awaitIntegration: "Esperando integración",
		removeIntegrationModal: {
			button: "Eliminar integración",
			title: "Eliminar integración",
			description: "¿Está seguro que desea eliminar las integraciones?",
			okText: "Confirmar",
			cancelText: "Cancelar",
		},
		emptyState: {
			title: "Aún no hay nada por aquí",
			description: "Parece que aún no tiene un delivery integrado.",
			button: "Integrar un Delivery",
		},
	},
	coalaConfig: {
		emptyState: {
			title: "Aún no hay nada por aquí",
			description: "Parece que aún no tiene menús para configurar.",
		},
	},
};
